"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_2 = require("@fluentui/react");
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var dompurify_1 = __importDefault(require("dompurify"));
require("./MarkDownIsland.scss");
var reducers_1 = require("../../reducers");
var MarkDownIslandType_1 = require("./MarkDownIslandType");
var connector = react_redux_1.connect(reducers_1.ComponentEtaMapStateToProps);
var MarkDownIsland = function (props) {
    var _a, _b, _c;
    var messageTypeProps = props.Type, propsCurrentLanguage = props.currentLang, currentUser = props.currentUser, messageData = props.messageData, code = props.code, onsetMessageBarData = props.onsetMessageBarData;
    var _d = react_1.useState(propsCurrentLanguage), currentLanguageState = _d[0], setCurrentLanguageState = _d[1];
    var _e = react_1.useState(messageData), messageBarData = _e[0], setMessageBarData = _e[1];
    var _f = react_1.useState(false), showImportantMessage = _f[0], setShowImportantMessage = _f[1];
    var _g = react_1.useState(false), showInformativeMessage = _g[0], setShowInformativeMessage = _g[1];
    var _h = react_1.useState(false), showFullMessage = _h[0], setFullMessage = _h[1];
    var _j = react_1.useState(''), error = _j[0], setError = _j[1];
    var location = react_router_dom_1.useLocation();
    var setShowMessege = function (Type, value) {
        var _a;
        switch (Type) {
            case MarkDownIslandType_1.MarkDownIslandType.Informative:
                setShowInformativeMessage(value);
                break;
            case MarkDownIslandType_1.MarkDownIslandType.Important:
                setShowImportantMessage(value);
                break;
            case MarkDownIslandType_1.MarkDownIslandType.Full:
                setFullMessage(value);
                break;
            case MarkDownIslandType_1.MarkDownIslandType.Errorr:
                setError((_a = messageBarData === null || messageBarData === void 0 ? void 0 : messageBarData.content) !== null && _a !== void 0 ? _a : '');
                break;
            default:
                break;
        }
    };
    var setOnLocalStorage = function (Id) {
        if (Id) {
            var key = (currentUser === null || currentUser === void 0 ? void 0 : currentUser.profile.email) + "/" + Id;
            localStorage.setItem(key, JSON.stringify({ key: key }));
            setShowMessege(messageTypeProps, false);
        }
    };
    var foundOnLocalStorage = function (key) {
        var found = localStorage.getItem((currentUser === null || currentUser === void 0 ? void 0 : currentUser.profile.email) + "/" + key);
        if (found)
            return true;
        return false;
    };
    var checkEmptyContent = function (content) {
        if (content) {
            var element = document.createElement('p');
            element.innerHTML = content;
            return !element.innerText.trim();
        }
        return true;
    };
    react_1.useEffect(function () {
        if (propsCurrentLanguage.lang !== currentLanguageState.lang) {
            setMessageBarData(undefined);
            setShowMessege(messageTypeProps, false);
            setCurrentLanguageState(propsCurrentLanguage);
        }
    }, [propsCurrentLanguage.lang]);
    react_1.useEffect(function () {
        var content = messageData === null || messageData === void 0 ? void 0 : messageData.content;
        if (!(content === null || content === undefined)) {
            if (!checkEmptyContent(content) &&
                !foundOnLocalStorage(messageData === null || messageData === void 0 ? void 0 : messageData.Key)) {
                setMessageBarData(messageData);
                setShowMessege(messageTypeProps, true);
            }
        }
        else
            setShowMessege(messageTypeProps, false);
    }, [messageData]);
    react_1.useEffect(function () {
        if (messageTypeProps && propsCurrentLanguage.lang) {
            onsetMessageBarData(code, propsCurrentLanguage);
        }
    }, [messageTypeProps, propsCurrentLanguage.lang, location]);
    var importanticon = { iconName: 'Megaphone' };
    return (react_1.default.createElement("span", null,
        error && (react_1.default.createElement(react_2.MessageBar, { messageBarType: react_2.MessageBarType.error, isMultiline: false, onDismiss: function () { return setError(''); } }, error)),
        showImportantMessage && (react_1.default.createElement(react_2.MessageBar, { messageBarType: react_2.MessageBarType.error, isMultiline: false, onDismiss: function () { return setOnLocalStorage(messageBarData === null || messageBarData === void 0 ? void 0 : messageBarData.Key); }, messageBarIconProps: importanticon, truncated: true, className: "show_messege" },
            react_1.default.createElement("span", { 
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML: {
                    __html: dompurify_1.default.sanitize((_a = messageBarData === null || messageBarData === void 0 ? void 0 : messageBarData.content) !== null && _a !== void 0 ? _a : ''),
                } }))),
        showInformativeMessage && (react_1.default.createElement(react_2.MessageBar, { messageBarType: react_2.MessageBarType.info, isMultiline: false, onDismiss: function () {
                setOnLocalStorage(messageBarData === null || messageBarData === void 0 ? void 0 : messageBarData.Key);
            }, truncated: true, className: "show_messege" },
            react_1.default.createElement("span", { 
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML: {
                    __html: dompurify_1.default.sanitize((_b = messageBarData === null || messageBarData === void 0 ? void 0 : messageBarData.content) !== null && _b !== void 0 ? _b : ''),
                } }))),
        showFullMessage && (react_1.default.createElement("div", { className: "dashboard-wrapper" },
            react_1.default.createElement("div", { className: "fullContent_messege", 
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML: {
                    __html: dompurify_1.default.sanitize((_c = messageBarData === null || messageBarData === void 0 ? void 0 : messageBarData.content) !== null && _c !== void 0 ? _c : ''),
                } })))));
};
exports.default = connector(MarkDownIsland);
//# sourceMappingURL=MarkDownIsland.js.map